// utils/pageMap.js

/**
 * Mapping between frontend routes and backend PageType enum IDs
 * This should match your C# PageType enum in the same order:
 * public enum PageType {
 *   Home = 0,
 *   About = 1,
 *   Cart = 2,
 *   Checkout = 3,
 *   Products = 4
 * }
 */

export const routeToPageId = {
  "/": 1,             // Home
  "/Home": 1,             // Home
  "/Gallery": 5,    // Gallery
  "/Contact": 6,      // Contact
  "/Career": 7      // Career
};

/**
 * Helper to get the PageType ID for a given route
 * @param {string} path - The current location.pathname
 * @returns {number|null} - The matching PageType ID or null if not found
 */
export function getPageTypeId(path) {
  if (!path) return null;

  // Normalize path: decode URI, lowercase, remove query params
  let normalizedPath = decodeURIComponent(path)
    .toLowerCase()
    .split("?")[0]; // Remove query string

  // Remove trailing slash(es) only if path is longer than 1 char
  if (normalizedPath.length > 1) {
    normalizedPath = normalizedPath.replace(/\/+$/, "");
  }

  // Check exact match first
  if (routeToPageId[normalizedPath]) return routeToPageId[normalizedPath];

  // Check startsWith for each route (also lowercase)
  for (const route in routeToPageId) {
    const normalizedRoute = route.toLowerCase();

    if (normalizedRoute === "/") {
      if (normalizedPath === "/") return routeToPageId[route];
      continue;
    }

    if (normalizedPath.startsWith(normalizedRoute)) {
      return routeToPageId[route];
    }
  }

  return null;
}